"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESentEmailType = void 0;
let ESentEmailType = exports.ESentEmailType = /*#__PURE__*/function (ESentEmailType) {
  ESentEmailType["Registration"] = "registration";
  ESentEmailType["Restore"] = "restore";
  return ESentEmailType;
}({});